import { StaticProvider } from '@angular/core';
import { FeatureServiceDef, provideFeature } from '@y42/feature';
import { Y42GitFolders } from '@y42/feature/git';
import { Y42Routes } from '@y42/feature/routing';
import { Y42FeatureType } from '@y42/json-schema';
import {
  OrchestrationAclService,
  OrchestrationGitService,
  OrchestrationQuery,
  OrchestrationService,
  OrchestrationStore,
} from '@y42/orchestration';
import { OrchestrationTabs } from './orchestration-tabs.constant';

const OrchestrationFeatureProviders: () => FeatureServiceDef = () => {
  return {
    FEATURE_TYPE: Y42FeatureType.Orchestration,
    GIT_FOLDER: Y42GitFolders.Orchestration,
    FEATURE_ROUTE: Y42Routes.Orchestration,
    DETAIL_TABS: OrchestrationTabs,
    AbstractFeatureService: OrchestrationService,
    AbstractFeatureQueryEntity: OrchestrationQuery,
    AbstractFeatureEntityStore: OrchestrationStore,
    AbstractFeatureGitService: OrchestrationGitService,
    AbstractFeatureAclService: OrchestrationAclService,
    AbstractFeatureChildQueryEntity: null,
  };
};

export function OrchestrationProviders(): StaticProvider[] {
  return provideFeature(OrchestrationFeatureProviders());
}
